"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Switch_1 = require("@material-ui/core/Switch/Switch");
var React = require("react");
var SelectionBase_1 = require("./Abstract/SelectionBase");
var FieldSwitch = /** @class */ (function (_super) {
    tslib_1.__extends(FieldSwitch, _super);
    function FieldSwitch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldSwitch.prototype.render = function () {
        return (React.createElement(SelectionBase_1.default, tslib_1.__assign({}, this.props, { value: this.props.value || null, Component: Switch_1.default })));
    };
    return FieldSwitch;
}(React.PureComponent));
exports.default = FieldSwitch;
//# sourceMappingURL=Switch.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Switch.js
// module id = 489
// module chunks = 58